import { z } from "zod";
import type { PageId} from "../page-id";
import { pageIdZodSchema } from "../page-id";

const pageDeleteCommandZodSchema = z.object({
    _type: z.literal("PAGE_DELETE_COMMAND"),
    pageId: pageIdZodSchema,
});

type PageDeleteCommand = z.infer<typeof pageDeleteCommandZodSchema>;

const pageDeleteCommandFactory = (pageId: PageId): PageDeleteCommand => {
    return {
        _type: "PAGE_DELETE_COMMAND",
        pageId,
    };
};

export { pageDeleteCommandZodSchema, pageDeleteCommandFactory };
export type { PageDeleteCommand };
